"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SphereGfx = void 0;
const three_12 = require("three");
const OrbitControls_js_3 = require("three/examples/jsm/controls/OrbitControls.js");
const redSphere_Shader_1 = require("./shaders/sphereShaders/redSphere.Shader");
const blueSphere_Shader_1 = require("./shaders/sphereShaders/blueSphere.Shader");
const points_Shader_1 = require("./shaders/sphereShaders/points.Shader");
const backgroundL_Shader_1 = require("./shaders/sphereShaders/backgroundL.Shader");
const backgroundR_Shader_1 = require("./shaders/sphereShaders/backgroundR.Shader");
const tweakpane_4 = require("tweakpane");
//
class SphereGfx {
    constructor() {
        this.elapsedTime = 0;
        this.velocityAttribute = [];
        this.numbersOfPoints = 1000;
        this.previousRenderScene = this.renderScene;
        this.sizes = {
            width: 0,
            height: 0
        };
        this.tick = () => {
            window.requestAnimationFrame(this.tick);
            if (this.renderScene !== this.previousRenderScene) {
                this.previousRenderScene = this.renderScene;
                if (this.backgroundColorTwp) {
                    this.backgroundColorTwp.hidden = !this.renderScene;
                }
            }
            //
            this.delta = this.clock.getDelta() * 1000;
            this.elapsedTime += this.delta;
            if (this.sizes.width !== window.innerWidth || this.sizes.height !== window.innerHeight) {
                this.resize();
            }
            ;
            if (this.redSphere)
                this.redSphereMaterial.uniforms.uTime.value = this.elapsedTime / 300;
            if (this.blueSphere) {
                this.blueSphereMaterial.uniforms.uTime.value = this.elapsedTime / 300;
                this.pointsShaderMaterial.uniforms.uTime.value = this.elapsedTime / 300;
            }
            ;
            if (this.points)
                this.updatePointsPositions(this.elapsedTime);
            if (this.planeL)
                this.backgroundLShaderMaterial.uniforms.uTime.value = this.elapsedTime / 300;
            if (this.planeR)
                this.backgroundRShaderMaterial.uniforms.uTime.value = this.elapsedTime / 300;
            let sliderPos = Math.sin(this.elapsedTime * 0.001) * 100;
            // this.controls.update();
            this.renderer.setScissor(0, 0, window.innerWidth / 2 - sliderPos, window.innerHeight);
            this.renderer.render(this.sceneL, this.camera);
            this.renderer.setScissor(window.innerWidth / 2 - sliderPos, 0, window.innerWidth / 2 + sliderPos, window.innerHeight);
            this.renderer.render(this.sceneR, this.camera);
        };
        console.log('sphere loaded!');
    }
    ;
    init() {
        // Canvas
        this.canvas = document.querySelector('canvas.webglViewSphere');
        // Scene
        this.sceneL = new three_12.Scene();
        this.sceneL.background = new three_12.Color('#b3afbd');
        this.sceneR = new three_12.Scene();
        this.sceneR.background = new three_12.Color('#b3afbd');
        // Sizes
        this.sizes.width = window.innerWidth,
            this.sizes.height = window.innerHeight;
        // Camera
        this.camera = new three_12.PerspectiveCamera(45, this.sizes.width / this.sizes.height, 0.1, 100);
        this.camera.position.set(0, 0, 2.1);
        this.sceneL.add(this.camera);
        const ambientLight = new three_12.AmbientLight(0xffffff, 0.4);
        this.sceneL.add(ambientLight);
        // Controls
        this.controls = new OrbitControls_js_3.MapControls(this.camera, this.canvas);
        // this.controls.enableZoom = false;
        this.controls.minDistance = 0.8;
        this.controls.maxDistance = 2.5;
        // Renderer
        this.renderer = new three_12.WebGLRenderer({ canvas: this.canvas, antialias: true });
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        this.renderer.setScissorTest(true);
        // Resize
        window.addEventListener('resize', this.resize());
        this.clock = new three_12.Clock();
        //
        this.addRedSphere();
        this.addBlueSphere();
        this.addBackgroundL();
        this.addBackgroundR();
        this.debug();
        //
        this.tick();
    }
    ;
    addRedSphere() {
        this.redSphereMaterial = new redSphere_Shader_1.RedSphereMaterial();
        const sphereGeom = new three_12.SphereBufferGeometry(0.45);
        this.redSphere = new three_12.Mesh(sphereGeom, this.redSphereMaterial);
        this.sceneL.add(this.redSphere);
    }
    ;
    addBlueSphere() {
        this.blueSphereMaterial = new blueSphere_Shader_1.BlueSphereMaterial();
        const sphereGeom = new three_12.SphereBufferGeometry(0.4, 5000);
        this.blueSphere = new three_12.Mesh(sphereGeom, this.blueSphereMaterial);
        this.sceneR.add(this.blueSphere);
        const colors = [];
        const sizes = [];
        const positionAttribute = [];
        const color = new three_12.Color();
        for (let i = 0; i < this.numbersOfPoints; i++) {
            color.setHSL(Math.floor(Math.random() * (255 + 1)), Math.floor(Math.random() * (255 + 1)), Math.floor(Math.random() * (255 + 1)));
            color.toArray(colors, i * 3);
            sizes[i] = 0.04 * Math.random(); // + 0.02;
            let x = (Math.random() - 0.5) * 0.2;
            let y = (Math.random() - 0.5) * 0.2;
            let z = (Math.random() - 0.5) * 0.2;
            if (Math.abs(x) < 0.1) {
                x = (Math.random() - 0.5) * 1.2;
            }
            ;
            if (Math.abs(y) < 0.1) {
                y = (Math.random() - 0.5) * 1.2;
            }
            ;
            if (Math.abs(z) < 0.1) {
                z = (Math.random() - 0.5) * 1.2;
            }
            ;
            positionAttribute.push(x, y, z);
            this.velocityAttribute.push((Math.random() - 0.5) * 10, (Math.random() - 0.5) * 10, (Math.random() - 0.5) * 10);
        }
        ;
        this.pointsShaderMaterial = new points_Shader_1.PointsShaderMaterial();
        this.pointGeometry = new three_12.BufferGeometry();
        this.pointGeometry.setAttribute('position', new three_12.Float32BufferAttribute(positionAttribute, 3));
        this.pointGeometry.setAttribute('velocity', new three_12.Float32BufferAttribute(this.velocityAttribute, 3));
        this.pointGeometry.setAttribute('color', new three_12.Float32BufferAttribute(colors, 3));
        this.pointGeometry.setAttribute('size', new three_12.Float32BufferAttribute(sizes, 1));
        this.points = new three_12.Points(this.pointGeometry, this.pointsShaderMaterial);
        this.sceneR.add(this.points);
    }
    ;
    updatePointsPositions(elapsedTime) {
        for (let i = 0; i < this.numbersOfPoints; i++) {
            this.points.geometry.attributes.velocity.setXYZ(i, Math.sin(i + elapsedTime / 2700) * 0.0006, Math.sin(i + elapsedTime / 2700) * 0.0006, Math.cos(elapsedTime / 2700) * 0.0006);
            let x = this.points.geometry.attributes.position.getX(i) + this.points.geometry.attributes.velocity.getX(i);
            let y = this.points.geometry.attributes.position.getY(i) + this.points.geometry.attributes.velocity.getY(i);
            let z = this.points.geometry.attributes.position.getZ(i) + this.points.geometry.attributes.velocity.getZ(i);
            this.points.geometry.attributes.position.setXYZ(i, x, y, z);
        }
        ;
        this.points.geometry.attributes.position.needsUpdate = true;
        this.points.geometry.attributes.velocity.needsUpdate = true;
    }
    ;
    addBackgroundL() {
        this.backgroundLShaderMaterial = new backgroundL_Shader_1.BackgroundLShaderMaterial();
        let planeGeometry = new three_12.PlaneGeometry(6, 6);
        this.planeL = new three_12.Mesh(planeGeometry, this.backgroundLShaderMaterial);
        this.sceneL.add(this.planeL);
    }
    ;
    addBackgroundR() {
        this.backgroundRShaderMaterial = new backgroundR_Shader_1.BackgroundRShaderMaterial();
        let planeGeometry = new three_12.PlaneGeometry(6, 6);
        this.planeR = new three_12.Mesh(planeGeometry, this.backgroundRShaderMaterial);
        this.sceneR.add(this.planeR);
    }
    ;
    debug() {
        let props = {
            color: '#0f0017'
        };
        this.backgroundColorTwp = new tweakpane_4.Pane({ title: 'Background' });
        this.backgroundColorTwp.element.parentElement.style['width'] = '330px';
        this.backgroundColorTwp.addInput(props, 'color', { label: 'Right background' }).on('change', () => {
            this.backgroundRShaderMaterial.uniforms.uRedColor.value.setHex(parseInt(props.color.replace('#', '0x')));
        });
        this.backgroundColorTwp.addInput(props, 'color', { label: 'Left background' }).on('change', () => {
            this.backgroundLShaderMaterial.uniforms.uBlackColor.value.setHex(parseInt(props.color.replace('#', '0x')));
        });
    }
    ;
    resize() {
        this.sizes.width = window.innerWidth;
        this.sizes.height = window.innerHeight;
        this.camera.aspect = this.sizes.width / this.sizes.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    }
    ;
}
exports.SphereGfx = SphereGfx;
exports.default = new SphereGfx();
